module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/alarm_clock-4f39aa5784844adf17171ba0b61b79f7.svg";